import React, { useState, useEffect } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit } from '@fortawesome/free-solid-svg-icons';
import { Row, Col } from 'reactstrap';

//Helpers
import { showMessage } from '../../../helpers/message';
import { validarCampos, objCampo } from '../../../helpers/ValidadorDeCampos';

//Components
import MainCard from '../../../components/MainCard/MainCard';
import TextField from '../../../components/TextField/TextField';
import TabelaListagem from '../../../components/TabelaListagem/TabelaListagem';
import ModalCustomized from '../../../components/Modal/Modal';

//Constants
import { actionsTable } from '../../../constants/MaterialTable';

//Context
import { useAuth } from 'context/auth';

//Api
import documento_api from '../../../api/documento_api';

//estado inicial do documento
function initialStateDocumento() {
    return {
        identificacao: "",
        descricao: "",
        ativo: "true",
        cadastroGerador: "",
        cadastroTransportador: "",
        cadastroDestino: ""
    }
}


export default function Documentos({ permissao }) {
    const { setLoading } = useAuth();
    //Estado que guarda os dados do documento para cadastrar/editar
    const [documento, setDocumento] = useState(initialStateDocumento());

    //Estado que guarda a lista de documentos
    const [listDocumentos, setListDocumentos] = useState([]);

    //Estado para as categorias do gerador
    const [categoriasGerador, setCategoriasGerador] = useState([]);

    //Estado de controle de exibição do modal de edição/cadastro
    const [openModal, setOpenModal] = useState(false);

    //Estado de controle dos erros nos campos obrigatorios
    const [errors, setErrors] = useState({});

    //Campos obrigatorios do formulario de documento
    const campos = [
        objCampo({ name: "identificacao", required: true }),
        objCampo({ name: "descricao", required: true }),
        objCampo({ name: "ativo", required: true }),
        objCampo({ name: "cadastroGerador", required: true }),
        objCampo({ name: "cadastroTransportador", required: true }),
        objCampo({ name: "cadastroDestino", required: true }),
    ]

    //Opções para o select de status
    const optionsStatus = [
        { text: "Sim", value: "true" },
        { text: "Não", value: "false" },
    ];

    //Opções para o select de status
    const optionsObrigatoriedadeDocumentos = [
        { label: "Não exibir", value: "Não exibir" },
        { label: "Opcional", value: "Opcional" },
        { label: "Obrigatório", value: "Obrigatório" },
    ]

    //Função que carrega os documentos
    const loadDocumentos = () => {
        setLoading(true);
        documento_api.GetList().then(response => {
            response.data = response.data.map(value => {
                value.ativo = value.ativo.toString();
                return value;
            });

            setListDocumentos(response.data);
        }).catch(e => showMessage("Aviso", e.message, "error", null))
            .finally(f => setLoading(false));
    }

    //Função para buscar as categorias do gerador
    const loadCategoriasGerador = (documentoId) => {
        documento_api.GetCategoriasGerador(documentoId).then(response => {
            setCategoriasGerador(response.data || []);
        }).catch(e => console.log(e));
    }

    //Função de controle do modal de edição/cadastro
    const toggleModal = () => {
        if (openModal) {
            setDocumento(initialStateDocumento());
            setErrors({});
            setCategoriasGerador([]);
        }
        setOpenModal(!openModal);
    }

    //OnChange dos campos do documento
    const onChangeDocuemnto = (e) => {
        const { name, value } = e.target;
        const _documento = {
            ...documento,
            [name]: value
        }
        const campo = campos.filter(c => c.name === name);
        const erros = validarCampos(_documento, campo);
        if (erros[1].length == 0) {
            const _errors = { ...errors };
            delete _errors[name];
            setErrors(_errors);
        } else {
            setErrors({ ...errors, ...erros[0] })
        }
        setDocumento(_documento)
    }

    //onChange para a questão vinculada
    const onChangeDocuemntoSearch = (e, select) => {
        const { name } = select;

        const _documento = {
            ...documento,
            [select.name]: e != null ? e.value : null,
        };

        const campo = campos.filter(c => c.name === name);
        const _errors = validarCampos(_documento, campo);

        if (_errors[1].length > 0) {
            setErrors({ ...errors, ..._errors[0] });
        } else {
            _errors[1] = { ...errors };
            delete _errors[1][name];
            setErrors(_errors[1]);
        }

        setDocumento(_documento);
    }

    //Função que faz o cadastro / edição do documento
    const addDocumento = async () => {
        const _errors = validarCampos(documento, campos);

        if (_errors[1].length > 0) {
            setErrors(_errors[0]);
            return;
        }

        const _documento = { ...documento };

        try {
            setLoading(true);

            if (documento.id) {
                await documento_api.Put(_documento);

                await documento_api.SalvarCategoriasGerador(
                    documento.id,
                    _documento.cadastroGerador === "Não exibir" ? [] : categoriasGerador
                );

                showMessage(
                    "Sucesso",
                    "Sucesso ao editar o documento",
                    "success",
                    () => {
                        loadDocumentos();
                        toggleModal();
                    }
                );
            } else {
                const { data } = await documento_api.Post(_documento);

                console.log(data)

                await documento_api.SalvarCategoriasGerador(
                    data.id,
                    _documento.cadastroGerador === "Não exibir" ? [] : categoriasGerador
                );
                showMessage(
                    "Sucesso",
                    "Sucesso ao cadastrar o documento",
                    "success",
                    () => {
                        loadDocumentos();
                        toggleModal();
                    }
                );
            } 
        } catch (e) {
            showMessage("Aviso", e.message, "error", null);
        } finally {
            setLoading(false);
        }
    };

    //Função que executa o procedimento de edição ao clicar no botão da tabela
    const editarDocumento = (item, itemKey) => {
        setDocumento(item);
        loadCategoriasGerador(item.id);
        toggleModal();
    }

    //Cabeçalhos da tabela de listagem
    const headers = [
        { value: "Identificação", objectValue: "identificacao", align: "left" },
        { value: "Descrição", objectValue: "descricao", align: "left" },
        {
            value: "Ativo", objectValue: "ativo", options: {
                filter: false,
                customBodyRenderLite: (dataIndex) => {
                    return listDocumentos[dataIndex]?.ativo == "true" ? "Sim" : "Não";
                }
            }
        },
        { value: "Destino", objectValue: "cadastroDestino", align: "left" },
        { value: "Gerador", objectValue: "cadastroGerador", align: "left" },
        { value: "Transportador", objectValue: "cadastroTransportador", align: "left" },
    ];

    const actions = [];
    if (permissao === "Editar")
        actions.push(actionsTable.editar(editarDocumento));

    //Carrega a lista de ramos de atividade assim que a tela é carregada
    useEffect(() => {
        loadDocumentos();
    }, []);

    return (
        <>
            <MainCard
                noCard
                btnCadastro={permissao === "Editar" ? "Adicionar" : null}
                onClickBtnCadastro={() => {
                    loadCategoriasGerador(0);
                    toggleModal();
                }}
            >
                <ModalCustomized
                    isOpen={openModal}
                    toggle={toggleModal}
                    title={documento.id ? <><FontAwesomeIcon icon={faEdit} /> Editar documento</> : "+ Adicionar novo documento"}
                    btnAction={documento.id ? <><FontAwesomeIcon icon={faEdit} /> Editar</> : "+ Adicionar"}
                    btnActionColor={documento.id ? "warning text-light" : "success"}
                    onClickBtnAction={addDocumento}
                    btnClose
                >
                    <Row className='mb-4'>
                        <Col md="12" lg="12"><span className="text-danger fw-bold">*</span> Campos obrigatórios</Col>
                    </Row>
                    <Row>
                        <Col lg={8}>
                            <TextField
                                maxLength={"150"}
                                invalid={!!errors.identificacao}
                                label={"* Identificação"}
                                name="identificacao"
                                value={documento.identificacao}
                                onChange={onChangeDocuemnto}
                            />
                        </Col>
                        <Col lg={4}>
                            <TextField
                                invalid={!!errors.ativo}
                                label={"* Ativo"}
                                name="ativo"
                                type={"select"}
                                options={optionsStatus}
                                value={documento.ativo}
                                onChange={onChangeDocuemnto}
                            />
                        </Col>
                        <Col lg={12}>
                            <TextField
                                invalid={!!errors.descricao}
                                label={"* Descrição"}
                                type={"textarea"}
                                name="descricao"
                                value={documento.descricao}
                                onChange={onChangeDocuemnto}
                                maxLength={300}
                            />
                        </Col>

                        <Col lg={4}>
                            <TextField
                                invalid={!!errors.cadastroDestino}
                                label={"* Destino"}
                                name="cadastroDestino"
                                searchable
                                type={"select"}
                                options={optionsObrigatoriedadeDocumentos}
                                value={optionsObrigatoriedadeDocumentos?.filter(x => x.value == documento.cadastroDestino)[0]}
                                onChange={onChangeDocuemntoSearch}
                            />
                        </Col>
                        <Col lg={4}>
                            <TextField
                                invalid={!!errors.cadastroGerador}
                                label={"* Gerador"}
                                name="cadastroGerador"
                                searchable
                                type={"select"}
                                options={optionsObrigatoriedadeDocumentos}
                                value={optionsObrigatoriedadeDocumentos?.filter(x => x.value == documento.cadastroGerador)[0]}
                                onChange={onChangeDocuemntoSearch}
                            />
                        </Col>
                        <Col lg={4}>
                            <TextField
                                invalid={!!errors.cadastroTransportador}
                                label={"* Transportador"}
                                name="cadastroTransportador"
                                searchable
                                type={"select"}
                                options={optionsObrigatoriedadeDocumentos}
                                value={optionsObrigatoriedadeDocumentos?.filter(x => x.value == documento.cadastroTransportador)[0]}
                                onChange={onChangeDocuemntoSearch}
                            />
                        </Col>
                        {documento.cadastroGerador && documento.cadastroGerador !== "Não exibir" && categoriasGerador.length > 0 && (
                            <Col lg={12} className="mt-3">
                                <h6 className="fw-bold mb-3">Parametrizar exibição por categoria de gerador (opcional)</h6>
                                <div className="table-responsive">
                                    <table className="table table-bordered table-sm w-100">
                                        <thead className="table-light">
                                            <tr>
                                                <th>Categoria</th>
                                                <th style={{ width: '200px' }}>Exibição no Cadastro</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {categoriasGerador.map((cat, index) => (
                                                <tr key={cat.tbGeradoresCategorias_Id}>
                                                    <td className="align-middle">{cat.categoriaDescricao}</td>
                                                    <td>
                                                        <select
                                                            className="form-select form-select-sm"
                                                            value={cat.exibicao}
                                                            onChange={(e) => {
                                                                const novas = [...categoriasGerador];
                                                                novas[index].exibicao = e.target.value;
                                                                setCategoriasGerador(novas);
                                                            }}
                                                        >
                                                            <option value="Não exibir">Não exibir</option>
                                                            <option value="Opcional">Opcional</option>
                                                            <option value="Obrigatório">Obrigatório</option>
                                                        </select>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </Col>
                        )}
                    </Row>
                </ModalCustomized>

                <div className="mt-4">
                    <TabelaListagem
                        actions={actions}
                        title={"Lista de Documentos"}
                        options={{ print: false, search: true, pagination: true }}
                        headers={headers}
                        items={listDocumentos}
                    />
                </div>
            </MainCard >
        </>
    )
}